import React from 'react';
import { motion } from 'motion/react';
import styles from './Card.module.css';
import { SPRING } from '../../utils/motion';

// motion.create es costoso: se cachea por componente/etiqueta
const motionTags = new Map();
const getMotionTag = (Tag) => {
  if (typeof Tag === 'string' && motion[Tag]) return motion[Tag];
  if (!motionTags.has(Tag)) motionTags.set(Tag, motion.create(Tag));
  return motionTags.get(Tag);
};

export default function Card({
  children,
  className = '',
  hoverable = false,
  variant = 'solid',
  padding = 'md',
  as: Tag = 'div',
  ...props
}) {
  const classes = [
    styles.card,
    styles[padding] || styles.md,
    variant === 'glass' ? styles.glass : '',
    hoverable ? styles.hoverable : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (!hoverable) {
    return (
      <Tag className={classes} {...props}>
        {children}
      </Tag>
    );
  }

  const MotionTag = getMotionTag(Tag);
  return (
    <MotionTag
      className={classes}
      whileHover={{ y: -4 }}
      whileTap={{ scale: 0.99 }}
      transition={SPRING.snappy}
      {...props}
    >
      {children}
    </MotionTag>
  );
}
